module.exports = __webpack_public_path__ + "img/14.30b8ba14.jpg";